// extracted by mini-css-extract-plugin
export var divider = "_ft-7";
export var itemsToggle = "_ft-8";
export var mergeModal = "_ft-1";
export var optionCard = "_ft-4";
export var radioGroup = "_ft-6";
export var radioOption = "_ft-0";
export var selected = "_ft-5";
export var shipmentOptions = "_ft-2";
export var tableOptions = "_ft-3";